import { useSelector } from 'react-redux';
export const subscriptionUsageSelector = (state) => state.subscriptionsUsage;
export const useSelectSubscriptionUsage = () => {
    const subscriptionUsage = useSelector(subscriptionUsageSelector);
    return subscriptionUsage;
};
